import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {Stack} from 'shells/layout/stack/stack';
import type {SavedSettingToastState} from 'shells/saved-setting-toast/saved-setting-toast';
import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

type Props = {
    labelContent: string;
    description: string;
    isOn: boolean;
    onChange: () => void;
    isDisabled?: boolean;
    children?: React.ReactNode;
    state?: SavedSettingToastState;
};

export function ToggleSection(props: Props) {
    return (
        <FormField
            innerId='toggle-section'
            label={props.labelContent}
            sublabel={props.description}
            // @ts-expect-error
            description={props.description}
            saveToastState={props.state || 'initial'}
            noMargin={true}
        >
            <div className='mb-16'>
                <Stack isHorizontal={true} spacing={8}>
                    <Switch
                        isOn={props.isOn}
                        isRounded={true}
                        isDisabled={props.isDisabled}
                        onChange={props.onChange}
                    />
                    <Body>{props.isOn ? 'On' : 'Off'}</Body>
                </Stack>
            </div>
            {props.children}
        </FormField>
    );
}
